import {
  DialogAdditionalParamKey,
  DialogKey,
} from '@sorare/core/src/components/navigation/WithDialogs';
import { useCloseDialog } from '@sorare/core/src/hooks/navigation/useCloseDialog';
import { useDialogParam } from '@sorare/core/src/hooks/navigation/useDialogParam';

import { MatchViewDialog } from '../MatchViewDialog';

export const StandaloneMatchViewDialog = () => {
  const closeDialog = useCloseDialog();
  const gameId = useDialogParam(DialogKey.game);
  const playerSlugs = useDialogParam(DialogAdditionalParamKey.playerSlugs);

  if (!gameId) {
    return null;
  }

  return (
    <MatchViewDialog
      gameId={gameId}
      open
      onClose={() => {
        closeDialog(DialogKey.game, [DialogAdditionalParamKey.playerSlugs]);
      }}
      highlightedPlayerSlugs={playerSlugs?.split(',')}
    />
  );
};
